import { AnchorProvider } from '@coral-xyz/anchor'
import { getAssociatedTokenAddress } from '@solana/spl-token'
import { clusterApiUrl, Connection, LAMPORTS_PER_SOL, PublicKey } from '@solana/web3.js'
import BigNumber from 'bignumber.js'
import { TransactionReceipt, zeroAddress } from 'viem'

import { FromChain, ToChain } from '@/hooks/services/useChainInfo'
import { TokenMeta } from '@/hooks/services/useTokenInfo'

import Calculator from './calculator'
import { CommonTools } from './CommonTools'

export default class SolanaTools implements CommonTools {
  accountAddress?: string | undefined
  accountPublicKey?: PublicKey | undefined
  isConnected: boolean = false
  bridgeAddress: string
  connection: Connection
  provider?: AnchorProvider
  bridgePublicKey: PublicKey
  wallet: any

  constructor(chain: FromChain, onConnect: (address: string, isConnected: boolean) => void) {
    if (!window.tokenpocket.solana) throw new Error('No Solana wallet detected. Please install TokenPocket.')

    this.wallet = window.tokenpocket.solana
    // this.connection = new Connection(chain.rpc, 'confirmed')
    this.connection = new Connection(clusterApiUrl('devnet'), 'confirmed')
    this.bridgeAddress = chain.bridgeAddress
    this.bridgePublicKey = new PublicKey(chain.bridgeAddress)

    this.connect(onConnect)
  }

  async connect(onConnect: (address: string, isConnected: boolean) => void) {
    const { publicKey } = (await this.wallet.connect()) as unknown as { publicKey: PublicKey }
    this.provider = new AnchorProvider(this.connection, this.wallet)

    this.accountPublicKey = publicKey
    this.accountAddress = this.accountPublicKey.toBase58()
    this.isConnected = true
    onConnect(this.accountAddress, this.isConnected)
  }

  async bridge(parmas: {
    fromChain: FromChain
    toChain: ToChain
    fromToken: TokenMeta
    toToken: TokenMeta
    receviceAddress: string
    paymentAddress: string
    amount: number
    challengePeriod: number
    fee: BigNumber
    nativeFee: BigNumber
  }): Promise<TransactionReceipt | undefined> {
    if (!this.accountAddress) return
    console.log('>>>>>> parmas: ', parmas)
    // const { fromChain, toChain, fromToken, toToken, receviceAddress, amount, challengePeriod, nativeFee } = parmas
    // const isNative = fromToken.address.toLowerCase() === zeroAddress

    // const aprogram = new Program(rebateIDL, this.provider)
    // console.log('>>>>>> program.methods: ', aprogram)
    // const bprogram = new Program(SolanaBridgeIDL, this.provider)
    // console.log('>>>>>> program.methods: ', bprogram)

    // console.log('>>>>>> program: ', program)

    // if (isNative) {
    //   //
    // } else {
    //   //
    // }
  }
  async getBalance(tokenMeta: TokenMeta): Promise<string | undefined> {
    if (!this.accountPublicKey) return

    if (tokenMeta.address === zeroAddress) {
      const balanceLamports = await this.connection.getBalance(this.accountPublicKey)
      return Calculator.base(balanceLamports).divide(LAMPORTS_PER_SOL).toString()
    } else {
      const mint = new PublicKey(tokenMeta.address)
      const ata = await getAssociatedTokenAddress(mint, this.accountPublicKey)
      const balance = await this.connection.getTokenAccountBalance(ata)
      return balance.value.uiAmountString
    }
  }
}
